import { CHANGE_RULES } from '../constants'
import { convertRule } from '../utils'

export default unitSet => async (dispatch, getState) => {
    const { curves, localRules } = getState().editorReducer

    const converted = await Promise.all(localRules.map(rule => convertRule(rule, unitSet, curves)))

    dispatch({
        type: CHANGE_RULES,
        changes: converted.map(rule => ({ index: rule.index, keyVals: { conditions: rule.conditions } })),
        update: true
    })
}
